import { useEffect, useState } from 'react';
import SelectDropdown from '../../Shared/SelectDropdown';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { TemplateActions } from '../../../Services/_actions/Template/template.actions';
import { InterveneActions } from '../../../Services/_actions/Intervene/intervene.actions';
import { channelListAtom, interveneFilterAtom, userDetailAtom, userInformationAtom, WhatsAppTempFormAtom } from '../../../Services/_states';
import SendTemplateForm from '../../Whatsapp/Template/sendTemplateForm';
import { Box, FormGroup, Grid, TextField } from '@mui/material';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import BotNumberDropdown from '../../Shared/BotNumberDropdown/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

const SendTemplateModal = ({ handleCloseModal = () => { } }) => {
  const loggedInUser = useRecoilValue(userInformationAtom)
  const interveneFilter = useRecoilValue(interveneFilterAtom);
  const tempActions = TemplateActions();
  const interveneActions = InterveneActions();
  const userDetails = useRecoilValue(userDetailAtom);
  const channelList = useRecoilValue(channelListAtom);
  const setWhatsappTempFormData = useSetRecoilState(WhatsAppTempFormAtom);
  const resetWhatsappTempFormData = useResetRecoilState(WhatsAppTempFormAtom);
  const [templateList, setTemplateList] = useState([]);
  const [paramsObj, setParamsObj] = useState({});
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [filters, setFilters] = useState({
    page: 0,
    search: '',
    channelObj: null,
    botNumber: '',
    sortField: 'created_at',
    sortOrder: 'desc',
    category: '',
    organisationObj: null,
  });
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const validateData = () => {
    let errors = {};
    selectedTemplate?.param?.map((item) => {
      if (!paramsObj[item]) errors[item] = `${item} field is required`;
    });
    setValidationError(errors);
    return Object.keys(errors)?.length;
  };

  const getTemplateList = async (filters) => {
    let res = await tempActions.getWhatsappTemplateList(filters);
    setTemplateList(res?.list);
  };
  const getSelectedTemplate = (e) => {
    setSelectedTemplate(e);
    if (e && (e?.messaging_product === 'whatsapp' || e?.source_name === "whatsapp" || e?.source_name === "trustsignal" || e?.source === "whatsapp" || e?.source === "trustsignal")) setWhatsappTempFormData(e);
    let obj = {};
    e?.param?.forEach((key) => {
      obj[key] = '';
    });
    setParamsObj(obj);
  };

  const handleChange = (e, item) => {
    let obj = paramsObj;
    obj[item] = e?.target?.value;
    setParamsObj(obj);
  };

  const SendTemplate = async () => {
    setIsLoading(true);
    let paramArr = Object.values(paramsObj);
    let error = validateData();
    if (error) {
      return 0;
    }

    let dataObj = [
      {
        phone_number: userDetails?.phone_number,
        template_id: selectedTemplate?.id,
        default_params: selectedTemplate?.param,
        params: paramArr,
        botNumber: filters?.botNumber || '',
      },
    ];
    await tempActions.sendTemplate(dataObj);
    setIsLoading(false);
  };

  const handleSelectBot = (e) => {
    setFilters({ ...filters, channelObj: e, botNumber: e?.wa_phone_number });
    getTemplateList({ ...filters, channelObj: e, botNumber: e?.wa_phone_number });
    setSelectedTemplate(null);
    resetWhatsappTempFormData();
    setValidationError({});
  };

  // useEffect(() => {
  //   if (channelList?.length <= 0) {
  //     interveneActions.getAllChannels();
  //   }
  // }, []);

  useEffect(() => {
    if (interveneFilter?.channelObj || interveneFilter?.organisationObj) {
      const channelObj = interveneFilter?.channelObj;
      let updatedFilters = { ...filters };

      if (channelObj) {
        updatedFilters = {
          ...updatedFilters,
          channelObj,
          botNumber: channelObj.wa_phone_number,
        };
        getTemplateList(updatedFilters);
      } else {
        console.warn("Channel object not found for the provided bot number");
      }

      const organisationObj = interveneFilter?.organisationObj;
      if (organisationObj) {
        updatedFilters = {
          ...updatedFilters,
          organisationObj,
        };
      } else {
        console.warn("Organisation object not found");
      }

      setFilters(updatedFilters);
    } else if (channelList?.length === 1) {
      const singleChannel = channelList[0];
      const updatedFilters = {
        ...filters,
        channelObj: singleChannel,
        botNumber: singleChannel?.wa_phone_number,
      };
      setFilters(updatedFilters);
      getTemplateList(updatedFilters);
    } else {
      console.warn("No bot number provided and multiple or zero channels in channelList");
    }
  }, [interveneFilter]);

  // useEffect(() => {
  //   if (userDetails?.bot_number) {
  //     const channelObj = channelList?.find(
  //       item => item?.wa_phone_number === userDetails?.bot_number
  //     );

  //     if (channelObj) {
  //       const updatedFilters = {
  //         ...filters,
  //         channelObj,
  //         botNumber: channelObj.wa_phone_number,
  //       };

  //       setFilters(updatedFilters);
  //       getTemplateList(updatedFilters);
  //     } else {
  //       console.warn("Channel object not found for the provided bot number");
  //     }
  //   } else if (channelList?.length === 1) {
  //     const singleChannel = channelList[0];
  //     const updatedFilters = {
  //       ...filters,
  //       channelObj: singleChannel,
  //       botNumber: singleChannel?.wa_phone_number,
  //     };

  //     setFilters(updatedFilters);
  //     getTemplateList(updatedFilters);
  //   } else {
  //     console.warn("No bot number provided and multiple or zero channels in channelList");
  //   }
  // }, [channelList, userDetails?.bot_number]);

  return (
    <>
      <Box mb={2}>
        {loggedInUser?.is_superuser && (
          <OrganisationDropdown
            value={filters?.organisationObj || null}
            onChange={(selected) => {
              const newFilters = {
                ...filters,
                organisationObj: selected,
                channelObj: null,
                botNumber: ""
              };
              resetWhatsappTempFormData();
              setSelectedTemplate(null);
              setFilters(newFilters);
            }}
            label={"Select Organisation"}
          />
        )}
      </Box>
      <Box mb={2}>
        <BotNumberDropdown
          organisation={loggedInUser?.is_superuser ? filters?.organisationObj : loggedInUser?.profile?.organisation || null}
          onChange={handleSelectBot}
          value={filters?.channelObj}
          label="Select Bot Number"
        />
      </Box>
      <SearchableDropdown
        options={templateList}
        value={selectedTemplate}
        label={"Select Template"}
        labelKey='name'
        valueKey="md_id"
        onChange={getSelectedTemplate}
        // onSearch={(e) => getTemplateList({ ...filters, search: e })}
      />
      <br />
      {(selectedTemplate?.messaging_product === 'whatsapp' || selectedTemplate?.source_name === "whatsapp" || selectedTemplate?.source_name === "trustsignal" || selectedTemplate?.source === "whatsapp" || selectedTemplate?.source === "trustsignal") ? (
        <SendTemplateForm phoneNumber={userDetails?.phone_number} handleCloseModal={handleCloseModal} />
      ) : null
        // (
        //   <div>
        //     {selectedTemplate?.data && (
        //       <p>
        //         <strong>Message : </strong> {selectedTemplate?.data ? selectedTemplate?.data : ''}.
        //       </p>
        //     )}
        //     <Box>
        //       {selectedTemplate &&
        //         selectedTemplate?.param?.map((item, index) => {
        //           return (
        //             <Grid item xs={12} sm={4} key={index}>
        //               <FormGroup sx={{ my: 2 }}>
        //                 <TextField
        //                   fullWidth
        //                   variant="outlined"
        //                   size='small'
        //                   label={item}
        //                   onChange={(e) => handleChange(e, item)}
        //                   error={Boolean(validationError[item])}
        //                   helperText={validationError[item] || ""}
        //                 />
        //               </FormGroup>
        //             </Grid>
        //           );
        //         })}
        //     </Box>
        //     <Box sx={{ float: 'right' }}>
        //       <LoadingButton
        //         buttonName="Send"
        //         onClickButton={SendTemplate}
        //         isDisabled={!selectedTemplate?.md_id}
        //         isLoading={isLoading}
        //       />
        //     </Box>
        //   </div>
        // )
      }
    </>
  );
};
export default SendTemplateModal;
